import {
  useApplyTheme,
  useTheme,
  type Theme,
  type ThemeConfig,
} from '../../shared/theme/useTheme.js'

/**
 * Owner (and staff) theme — a thin wrapper over the shared `useTheme`
 * primitive. The owner app is light-first (its light palette mirrors the
 * marketing site; its dark palette mirrors admin's). Scoped under
 * `.owner-root` via the `data-owner-theme` <html> attribute, persisted under
 * `naya:owner-theme` — a separate key + attribute + scope from admin's so the
 * two never collide.
 *
 * Staff UI uses this same hook: staff is part of the owner-side app from a
 * code-organization standpoint.
 */

export type OwnerTheme = Theme

const OWNER_THEME_CONFIG: ThemeConfig = {
  storageKey: 'naya:owner-theme',
  attr: 'data-owner-theme',
  defaultTheme: 'light',
}

/** Apply the saved owner theme to <html> tree-wide (call once in OwnerApp/StaffApp). */
export function useApplyOwnerTheme(): void {
  useApplyTheme(OWNER_THEME_CONFIG)
}

/** Stateful owner theme hook for the header ThemeToggle. */
export function useOwnerTheme(): { theme: OwnerTheme; toggle: () => void } {
  return useTheme(OWNER_THEME_CONFIG)
}
